var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"58857319620beac05e7505a791d3bf564c7c870d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["landing-v2@staderlabs"]={id:"58857319620beac05e7505a791d3bf564c7c870d"};
      